import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import { ProductSale } from 'src/app/models/cash-flow/sale.model';
import { PaginationResult } from 'src/app/models/pagination-result.model';
import { paginateSalesSuccess } from '../actions/product-sale.action';
import { CashFlow } from 'src/app/models/cash-flow/cashFlow';

export interface ProductSaleState extends EntityState<CashFlow> {
  selectedSaleId: number | null;
  paginationResult: PaginationResult<CashFlow> | null;
  allValues: Array<CashFlow>;
}

export function selectedProductSaleId(a: CashFlow): number {
  return a.id ? a.id : 0;
}

export const productSaleAdapter: EntityAdapter<CashFlow> =
  createEntityAdapter<CashFlow>({
    selectId: selectedProductSaleId,
  });
export const initialProductSaleState: ProductSaleState =
  productSaleAdapter.getInitialState({
    selectedSaleId: null,
    paginationResult: null,
    allValues: [],
  });

export const productSales = createReducer(
  initialProductSaleState,
  on(paginateSalesSuccess, (state, { paginationResult }) => {
    if (paginationResult.meta.current_page == 1) {
      return productSaleAdapter.setAll(paginationResult.data, {
        ...state,
        allValues: paginationResult.data,
        paginationResult,
      });
    } else
      return productSaleAdapter.addMany(paginationResult.data, {
        ...state,
        allValues: state.allValues.concat(paginationResult.data),
        paginationResult,
      });
  })
);
